import { Routes } from '@angular/router';
import { LoginComponent, RegisterComponent } from './core/auth';
import { ForgotPasswordComponent } from './core/auth/forgot-password/forgot-password.component';
import { VerifyCodeComponent } from './core/auth/verify-code/verify-code.component';
import { ResetPasswordComponent } from './core/auth/reset-password/reset-password.component';
import { PortalComponent, NotificationsComponent, ContestDetailComponent, TermsOfUseComponent, PrivacyPolicyComponent, LgpdComponent } from './shared/pages';
import { authGuard, adminGuard, candidateGuard, evaluatorGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Public
  { path: '', redirectTo: '/portal', pathMatch: 'full' },
  { path: 'portal', component: PortalComponent },
  { path: 'login', component: LoginComponent },
  { path: 'cadastro', component: RegisterComponent },
  { path: 'recuperar-senha', component: ForgotPasswordComponent },
  { path: 'recuperar-senha/verificar', component: VerifyCodeComponent },
  { path: 'verificar-codigo', component: VerifyCodeComponent }, // Para login 2FA
  { path: 'recuperar-senha/nova-senha', component: ResetPasswordComponent },
  { path: 'portal/concurso/:id', component: ContestDetailComponent },
  { path: 'termos-de-uso', component: TermsOfUseComponent },
  { path: 'politica-privacidade', component: PrivacyPolicyComponent },
  { path: 'lgpd', component: LgpdComponent },

  // Shared Protected Routes (all authenticated users)
  {
    path: 'portal/notificacoes',
    component: NotificationsComponent,
    canActivate: [authGuard]
  },

  // Protected Candidate Routes
  {
    path: 'portal/candidato',
    loadChildren: () => import('./modules/candidate/candidate.routes').then(m => m.CANDIDATE_ROUTES),
    canActivate: [authGuard, candidateGuard]
  },

  // Protected Admin Routes
  {
    path: 'portal/admin',
    loadChildren: () => import('./modules/admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [authGuard, adminGuard]
  },

  // Protected Evaluator Routes
  {
    path: 'portal/avaliador',
    loadChildren: () => import('./modules/evaluator/evaluator.routes').then(m => m.EVALUATOR_ROUTES),
    canActivate: [authGuard, evaluatorGuard]
  },

  // Future protected routes
  // {
  //   path: 'fiscal',
  //   loadChildren: () => import('./modules/supervisor/supervisor.routes').then(m => m.SUPERVISOR_ROUTES),
  //   canActivate: [authGuard, supervisorGuard]
  // }
];
